import React from 'react'; // Using absolute import path
import * as ReactDOM from 'react-dom/client';
import App from './App';
import './index.css';
import { StoreProvider } from './store/store';

const root = ReactDOM.createRoot(document.getElementById('root')!);
root.render(
  <React.StrictMode>
    <StoreProvider>
      <App />
    </StoreProvider>
  </React.StrictMode>
);